<template>
  <div class="preview-email-container">
    <span class="font-16 fw-600 color-3" style="position: absolute; top: 35px; left: 15px;" v-html="data.emailThemeHtml"></span>
    <span class="font-12 color-9" style="position: absolute; top: 72.5px; left: 114px;">{{ data.payDate }}</span>
    <span class="font-12" style="position: absolute; top: 87px; left: 80px;">{{ data.empName }}</span>
    <div class="email-content" v-html="data.emailContentHtml"></div>
    <div class="flex vertical attachment-box" v-loading="downloading['10520002']" @click="handleDownload('10520002')">
      <span class="font-12 mt46 mb6">PDF工资条</span>
      <span class="font-12 color-9">请点击下载</span>
    </div>
    <div class="flex vertical attachment-box" style="left: 153px;" v-loading="downloading['10520003']" @click="handleDownload('10520003')">
      <span class="font-12 mt46 mb6">Excel工资条</span>
      <span class="font-12 color-9">请点击下载</span>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/v2/service-process/order'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      downloading: {
        10520002: false,
        10520003: false
      }
    }
  },
  methods: {
    handleDownload(type) {
      this.downloading[type] = true
      api.downloadPayslip({
        isZip: '10020001',
        type,
        salaryInfos: [{salaryDetailId: this.data.salaryDetailId}]
      }).then(res => {
        this.$downloadFile(res)
      }).finally(() => this.downloading[type] = false)
    }
  }
}
</script>

<style lang="scss" scoped>
.preview-email-container {
  width: 825px;
  height: 447px;
  background: url('~@/assets/img/v2/service-process/邮件预览背景.png') no-repeat;
  background-size: 100% 100%;
  position: relative;

  .email-content {
    position: absolute;
    padding: 0 20px;
    top: 130px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    text-align: left;
  }
  .attachment-box {
    position: absolute;
    width: 124px;
    height: 86px;
    left: 18px;
    bottom: 29px;
    cursor: pointer;
  }
}
</style>
